module.exports = __webpack_public_path__ + "a5ea5609460534be83b6dffacf5837e3.png";